var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ban-form',{attrs:{"title":"Ban Client","ban":_vm.form},on:{"addban":_vm.banClient}})
}
var staticRenderFns = []

export { render, staticRenderFns }